<template>
    <!-- activeEmbeddedComponents i.e. components used inside Angular templates and inserted using <Teleport> -->
    <component :is="component.name"
               v-for="component in activeEmbeddedComponents"
               v-bind="component.props"
               :key="component.name"></component>
</template>

<script>
import DojoWebPosPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/Dojo/DojoWebPosPaymentMethod';
import GiftVoucherPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/GiftVoucher/GiftVoucherPaymentMethod';
import GoCardlessPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/GoCardless/GoCardlessPaymentMethod';
import MellonWebECRPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRPaymentMethod';
import OrderDetailsView from '@/epos/vue/pages/order-details/OrderDetailsView';
import PaymentMethodTabs from '@/epos/vue/modals/Payment/components/PaymentMethodTabs';
import PayyoPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/Payyo/PayyoPaymentMethod';
import SellView from '@/epos/vue/pages/sell/SellView';
import TaxReceiptToggle from '@/epos/vue/modals/Payment/components/TaxReceiptToggle';
import TescoVoucherUkPaymentMethodComponent from '@/epos/vue/modals/Payment/PaymentMethods/Tesco/TescoVoucherUkPaymentMethod';
import { mapGetters } from 'vuex';

// Note: Our dynamic components don't have to <Teleport> themselves instead they can contain one or more child
// components that are teleported instead. For example see: <OrderDetailsView />.
export default {
    name: 'EmbeddedComponents',

    components: {
        DojoWebPosPaymentMethodComponent,
        GiftVoucherPaymentMethodComponent,
        GoCardlessPaymentMethodComponent,
        MellonWebECRPaymentMethodComponent,
        OrderDetailsView,
        PaymentMethodTabs,
        PayyoPaymentMethodComponent,
        SellView,
        TaxReceiptToggle,
        TescoVoucherUkPaymentMethodComponent,
    },

    computed: {
        ...mapGetters([
            'activeEmbeddedComponents',
        ]),
    },
};
</script>
